import React from 'react';
import UpcomingSection from '../../components/UpcomingSection/UpcomingSection';
import Carousel from '../../components/Carousel/Carousel';
import SessionSection from '../../components/SessionSection/SessionSection';
import Banner from '../../components/Banner/Banner';
import ErrorBoundary from '../../utils/Errorboundary';

function HomePage() {
  return (
    <>
      <div>
        <ErrorBoundary>
          <Carousel />
        </ErrorBoundary>

        <ErrorBoundary>
          <UpcomingSection />
        </ErrorBoundary>

        <Banner />

        <ErrorBoundary>
          <SessionSection />
        </ErrorBoundary>
      </div>
    </>
  );
}

export default HomePage;
